import { createSelector } from 'reselect';
import get from 'lodash/get';
import { cloneDeep, orderBy } from 'lodash';

import { DEFAULT_CONFIG_SORT } from '@utils/constants';
import { SCOPE } from './types';
import { configViewSelector } from '../base/selectors';

const selector = (state) => get(state, SCOPE);

export const loadingSelector = createSelector(selector, (configState) => ({
  loading: configState.isFetching,
  showError: configState.errorCode !== 0,
  errorMsg: configState.errorMsg,
}));

export const dataSelector = createSelector(selector, (configState) =>
  configState.response ? configState.response.data : {},
);

function getConfigRowSortValue(sortKey: string, row: Record<string, unknown>) {
  const key = sortKey || DEFAULT_CONFIG_SORT.key;
  if (key === 'updatedAt') {
    const t = new Date(row.updatedAt as string | number | Date).getTime();
    return Number.isNaN(t) ? 0 : t;
  }
  return get(row, key);
}

export const configDataSortSelector = createSelector(
  configViewSelector,
  dataSelector,
  (configData, tableData) => {
    // Merge so missing/partial persisted sort never leaves key/order undefined.
    const sort = { ...DEFAULT_CONFIG_SORT, ...(configData || {}) };
    const records: any[] = [];

    get(tableData, 'data', []).forEach((row) => {
      const value = row.rules.map((ele) => `Error ${ele.operator} ${ele.value}`).join(' OR ');
      // build row data
      const rowData = cloneDeep(row);
      const {
        updatedBy: { email, username },
      } = rowData;

      rowData.rules = value;
      rowData.rawRules = row.rules;
      rowData.updatedBy['email'] = email || username;

      // Remove deleted row (state may be string from API)
      if (Number(rowData.state) !== 0) {
        records.push(rowData);
      }
    });

    const sortKey = sort?.key || DEFAULT_CONFIG_SORT.key;
    const sortOrder = sort?.order || DEFAULT_CONFIG_SORT.order;

    const orderedRecords = orderBy(
      records,
      [(row) => getConfigRowSortValue(sortKey, row)],
      [sortOrder],
    );

    return {
      data: orderedRecords,
      sort: { ...sort, key: sortKey, order: sortOrder },
    };
  },
);

export default selector;
